import { api } from './api';
import { getAuthToken } from './authStorage';
import { absoluteUrl } from './pageSeo';
import { getProductPath } from './productUrl';
import { persistLastInquiry } from './orderCompletion';

function productSnapshot(product) {
  if (!product) return {};
  return {
    productId: String(product._id || product.id || '').trim(),
    productName: String(product.name || product.title || '').trim(),
    productUrl: absoluteUrl(getProductPath(product)),
    storeName: String(
      product.vendor?.name || product.storeName || product.vendorName || ''
    ).trim(),
  };
}

/** Ask the backend to record an inquiry. IDs, dates, and user binding are assigned server-side. */
export async function recordAvailabilityInquiry({ product, email = '', surveyConsent = false } = {}) {
  try {
    return await api.post(
      '/availability-inquiries',
      {
        ...productSnapshot(product),
        email: String(email || '').trim().toLowerCase(),
        surveyConsent: Boolean(surveyConsent),
        source: 'check_availability',
      },
      getAuthToken()
    );
  } catch {
    return { persisted: false, inquiry: null };
  }
}

/** True when this email/account already opted in to Google survey follow-up. */
export async function fetchSurveyConsentStatus(email = '') {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return { hasSurveyConsent: false };
  try {
    const query = new URLSearchParams({ email: normalized }).toString();
    return await api.get(`/availability-inquiries/survey-consent-status?${query}`, getAuthToken());
  } catch {
    return { hasSurveyConsent: false };
  }
}

export function saveInquiryForConfirmation(inquiry) {
  persistLastInquiry(inquiry);
}
